import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'ppToDate',
    standalone: false
})
export class ppToDate implements PipeTransform {

  transform(value: string): any {
    return value ? moment.utc(value).local().toDate() : null;
  }

}
